import React from "react";
import ModalWrap from "./ModalWrap";
import { Backdrop, Fade, Typography } from "@mui/material";
import "./removesuccess.scss";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { PERSON_DASHBOARD } from "../../routes/routerPath";
import { searchParams, handleParams } from "../../utlis/helpers";
import successTick from "../../assets/images/successTick.svg";
import { pageLocale, getCurrentLocale } from "../../utlis/locale";
import { isWebView, postWebViewMessage } from "../../utlis/webViewBridge";
import { userInfoFetch, formatName } from "../../utlis/commonFunction";

const RemoveSuccess = ({ removePopUp, setRemovePopup, userInfo }) => {
  const navigate = useNavigate();
  const { removed, ok } = pageLocale("popup");
  const okHandler = () => {
    setRemovePopup(false);
    if (isWebView()) {
      postWebViewMessage("BACK_TO_USER_LIST");
    } else {
      const seniorId = userInfoFetch()?.id;
      if (seniorId) {
        navigate(PERSON_DASHBOARD + handleParams("seniorId", seniorId));
      } else {
        navigate(PERSON_DASHBOARD + `${searchParams}`);
      }
    }
  };
  const displayName = formatName(userInfo, getCurrentLocale());
  return (
    <ModalWrap
      open={removePopUp}
      slots={{ backdrop: Backdrop }}
      className="remove-success-modal-wrapper"
      onClose={okHandler}
    >
      <Fade in={open}>
        <Box className="remove-modal-box">
          <img src={successTick} alt="success" className="success-img" />
          <Typography className="success-msg">
            {displayName} {removed}
          </Typography>
          <hr className="success-divider" />
          <button className="ok-btn" onClick={okHandler}>
            {ok}
          </button>
        </Box>
      </Fade>
    </ModalWrap>
  );
};

export default RemoveSuccess;
